import React, { useMemo, useRef } from 'react'; // <-- 1. Import useRef
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

import productData from '../data/products.json';
import ProductCard from '../components/ProductCard';
import { useDragToScroll } from '../hooks/useDragToScroll';

const StoreSection = () => {
  const featuredProducts = useMemo(() => {
    return productData.products.filter(p => p.category === 'Grams Pots' && p.availability === true).slice(0, 6);
  }, []);

  // --- 2. Create a ref for the carousel container ---
  const carouselRef = useRef(null);

  // --- 3. Create the event handler function for mouse wheel scrolling ---
  const handleWheelScroll = (event) => {
    if (carouselRef.current) {
      // Prevent the default vertical page scroll when the cursor is over the carousel
      event.preventDefault();
      // Translate the vertical scroll amount (deltaY) into horizontal scroll (scrollLeft)
      carouselRef.current.scrollLeft += event.deltaY;
    }
  };

   const { ref, onMouseDown, onMouseUp, onMouseLeave, onMouseMove } = useDragToScroll();

  if (featuredProducts.length === 0) {
    return null;
  }

  return (
    <div className="store-section-snippet">
      <header className="store-section-snippet__header">
        <h2 className="store-section-snippet__title">Featured Collection</h2>
        <Link to="/store" className="store-section-snippet__link">
          Shop All <ArrowRight size={16} />
        </Link>
      </header>

      {/* --- 4. Attach the ref and the onWheel event handler to the carousel div --- */}
      <div 
        className="store-section-snippet__carousel"
        ref={ref}
        onMouseDown={onMouseDown}
        onMouseUp={onMouseUp}
        onMouseLeave={onMouseLeave}
        onMouseMove={onMouseMove}
      >
        <div className="store-section-snippet__grid">
          {featuredProducts.map((product) => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default StoreSection;